export default __webpack_public_path__ + "static/media/icon_facility_taxi.0df1762e.svg";